import { type Project } from "@/lib/backend/api";
import { ProjectCardFeatured } from "./project-card.featured";

type ProjectCardCarouselProps = {
  // Draagt het focuspunt mee (app#114); zonder deze intersectie zou het type het
  // hier stilletjes verliezen terwijl de waarde er nog wel is.
  projects: Project[];
};

export function ProjectCardCarousel({ projects }: ProjectCardCarouselProps) {
  return (
    <div className="flex gap-3 overflow-x-auto scroll-smooth pb-4 [&::-webkit-scrollbar]:hidden">
      {projects.map((project) => (
        <div key={project.id} className="flex-none">
          <ProjectCardFeatured project={project} />
        </div>
      ))}
    </div>
  );
}
